import onDOMContentLoaded from '../utils/on-dom-content-loaded';

const getPageScrollProgress = () => {
  const scrollIndicator = document.getElementById('scroll-indicator');
  if (scrollIndicator) {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const scrollIndicatorFullElement = document.querySelector('.js-scroll-indicator-full');
    const headerAndProgressBarHeights =
      document.querySelector('header').clientHeight + scrollIndicatorFullElement.clientHeight;
    const scrollIndicatorFullElementScroll =
      scrollIndicatorFullElement.offsetTop - headerAndProgressBarHeights;
    const scrolled = (winScroll / scrollIndicatorFullElementScroll) * 100;

    scrollIndicator.style.width = `${scrolled}%`;
  }
};

const initScrollIndicator = () => {
  window.onscroll = () => {
    getPageScrollProgress();
  };
};

onDOMContentLoaded().then(() => initScrollIndicator());
